module.exports = __webpack_public_path__ + "img/girl-head-back.ab02ca4c.png";